import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '../utils/animations';
import { useLocalStorage } from '../hooks/useLocalStorage';

// Carte d'annonce de pause du developpement (accueil).
// Discrete, masquable, memorisee dans localStorage : une fois "Compris"
// tape, elle ne revient plus. Tous les outils restent en ligne - le ton
// doit rester calme, jamais une alerte ni une fermeture.
const COPY = {
  fr: {
    overline: 'PAUSE DOUCEUR',
    title: 'ColoBongo prend une pause',
    paragraphs: [
      "Tous les outils restent en ligne et gratuits. Le scan, Mon Frigo, le Mur, le Shade Builder, l'aide lumière : tout continue de fonctionner comme avant.",
      "Ce qui change, c'est le rythme. Je suis seul derrière ColoBongo et je dois lever le pied pour un bon moment, pour des raisons personnelles. Il n'y aura donc pas de nouvelles fonctionnalités majeures pour l'instant.",
      "Merci d'être là, et merci de colorier avec nous.",
    ],
    dismiss: 'Compris',
  },
  en: {
    overline: 'GENTLE PAUSE',
    title: 'ColoBongo is taking a break',
    paragraphs: [
      'All the tools stay online and free. The scan, My Fridge, the Wall, the Shade Builder, the light helper: everything keeps working just like before.',
      'What changes is the pace. I build ColoBongo on my own, and I need to step back for a while for personal reasons. So there will be no major new features for now.',
      'Thanks for being here, and thanks for coloring with us.',
    ],
    dismiss: 'Got it',
  },
};

export default function PauseNoticeCard({ language = 'fr' }) {
  const [dismissed, setDismissed] = useLocalStorage('colobongo_pause_notice_v1', false);
  if (dismissed) return null;

  const copy = COPY[language === 'fr' ? 'fr' : 'en'];

  return (
    <motion.div
      {...fadeInUp}
      className="mb-4"
      style={{
        background: 'var(--color-surface-soft)',
        border: '1px solid var(--cb-border)',
        borderRadius: 'var(--radius-xl)',
        boxShadow: 'var(--shadow-xs)',
        padding: 16,
      }}
    >
      <p
        style={{
          fontSize: 11,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.07em',
          color: 'var(--color-text-tertiary)',
        }}
      >
        {copy.overline}
      </p>

      <h3 className="mt-1" style={{ fontSize: 15, fontWeight: 700 }}>
        {copy.title}
      </h3>

      <div className="mt-2 space-y-2">
        {copy.paragraphs.map((paragraph, index) => (
          <p
            key={index}
            className="leading-relaxed"
            style={{ fontSize: 13.5, color: 'var(--color-text-secondary)' }}
          >
            {paragraph}
          </p>
        ))}
      </div>

      {/* Bouton texte discret : masque la carte, ne ressemble pas a un CTA. */}
      <div className="flex justify-end mt-2">
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="px-2 py-1"
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: 'var(--color-text-secondary)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          {copy.dismiss}
        </button>
      </div>
    </motion.div>
  );
}
